import { SimpleTable } from '@core/components/Table';
import { TableActionButton, TableActionButtonDelete, TableActionButtonEdit } from '@core/components/TableAction';
import TableActionContainer from '@core/components/TableAction/TableActionContainer';
import { permissaoUtils } from '@core/util/permissaoUtil';
import { formataQuantidade } from 'app/utils/mask';
import React, { useContext } from 'react';
import { FaToggleOff, FaToggleOn } from 'react-icons/fa';
import { ProdutoContext } from '../../ProdutoContext';
import ProdutoFab from '../ProdutoFab';
import { produtoModais } from '../modal/produtoModais';
import { produtoStyles } from './styles';

const getCurrency = (value) =>
  new Intl.NumberFormat('pt-BR', { style: 'currency', currency: 'BRL' }).format(value).replace('R$', '');

const ProdutoTable = ({ onSelection, fetchProdutos, fetchProduto, onInativar, onAtivar, onDelete, onTour }) => {
  const [produtos] = useContext(ProdutoContext).produtos;
  const [selecao] = useContext(ProdutoContext).selecao;
  const [loading] = useContext(ProdutoContext).loading;
  const [, setModal] = useContext(ProdutoContext).modal;
  const [, setPage] = useContext(ProdutoContext).page;
  const [, setSize] = useContext(ProdutoContext).size;
  const [totalElements] = useContext(ProdutoContext).totalElements;
  const [search] = useContext(ProdutoContext).search;
  const [tipoSelecao, setTipoSelecao] = useContext(ProdutoContext).tipoSelecao;
  const [filtroAvancado] = useContext(ProdutoContext).filtroAvancado;

  const styles = produtoStyles();

  const handleOpenModalVisualizar = async (produto) => {
    await fetchProduto(produto.id);
    setModal(produtoModais.visualizacaoProduto);
  };

  const handleOpenModalEditar = async (produto) => {
    await fetchProduto(produto.id);
    setModal(produtoModais.cadastroProduto);
  };

  const handleInativar = (produto) => {
    onInativar({ ids: [produto], q: search, tipoSelecao: 'NENHUM' });
  };

  const handleAtivar = (produto) => {
    onAtivar({ ids: [produto], q: search, tipoSelecao: 'NENHUM' });
  };

  const produtoColumnDefs = [
    {
      title: 'Nome do produto',
      name: 'nome',
      getCellValue: (produto) => {
        return (
          <div className={styles.descricaoContainer}>
            <span className={styles.descricao}>{produto.nome}</span>
            {produto.inativo ? <div className={styles.badgeInativo}>Inativo</div> : ''}
          </div>
        );
      },
      sortingEnabled: true,
    },
    {
      title: 'Código do produto (SKU)',
      name: 'codigo',
      sortingEnabled: true,
    },
    {
      title: 'Valor unitário da venda (R$)',
      name: 'valorUnitario',
      getCellValue: (produto) => {
        return produto?.valorUnitario ? getCurrency(produto.valorUnitario) : '-';
      },
      sortingEnabled: true,
      align: 'right',
      hideTooltip: true,
    },
    {
      title: 'Quantidade em estoque',
      name: 'quantidadeEstoque',
      align: 'center',
      sortingEnabled: true,
      hideTooltip: true,
      getCellValue: (produto) => {
        return formataQuantidade(produto.quantidadeEstoque);
      },
    },
    {
      name: '',
      title: '',
      sortingEnabled: false,
      align: 'left',
      width: 125,
      getCellValue: (produto) => (
        <>
          <TableActionContainer onTour={onTour}>
            {permissaoUtils.produto().editar && (
              <TableActionButtonEdit onClick={() => handleOpenModalEditar(produto)} className={'stepIconeEditar'} />
            )}
            {permissaoUtils.produto().excluir && (
              <TableActionButtonDelete
                onClick={() => onDelete({ ids: [produto], q: search, tipoSelecao: 'NENHUM' })}
                className={'stepIconeExcluir'}
              />
            )}
            {permissaoUtils.produto().editar && produto.inativo && (
              <TableActionButton
                icon={<FaToggleOn size={18} className={'stepIconeAtivar'} />}
                title="Ativar"
                onClick={() => handleAtivar(produto)}
                style={styles.buttonOnOff}
              />
            )}
            {permissaoUtils.produto().editar && !produto.inativo && (
              <TableActionButton
                icon={<FaToggleOff size={18} className={'stepIconeAtivar'} />}
                title="Inativar"
                onClick={() => handleInativar(produto)}
                style={styles.buttonOnOff}
              />
            )}
          </TableActionContainer>
        </>
      ),
    },
  ];

  return (
    <>
      <SimpleTable
        columns={produtoColumnDefs}
        rows={produtos}
        fetchData={fetchProdutos}
        loading={loading}
        onRowClick={handleOpenModalVisualizar}
        defaultSorting={[{ columnName: 'nome', direction: 'asc' }]}
        totalCount={totalElements}
        onCurrentPageChange={(params) => {
          setPage(params);
        }}
        onPageSizeChange={(params) => {
          setSize(params);
        }}
        selectionType={tipoSelecao}
        onSelectionTypeChange={(params) => {
          setTipoSelecao(params);
        }}
        // fetchOnCreate
        selection={selecao}
        onSelectionChange={onSelection}
        onSortingChange={(params) => console.log(params)}
        onLoadingChange={(params) => console.log('loading change', params)}
        searchBy={search}
        params={filtroAvancado}
        contemFiltroAvancado
      />
      {(permissaoUtils.produto().cadastrar || permissaoUtils.produto().excluir) && (
        <ProdutoFab
          selected={selecao.length}
          onInativar={onInativar}
          onAtivar={onAtivar}
          onDelete={onDelete}
          fetchProduto={fetchProduto}
        />
      )}
    </>
  );
};

export default ProdutoTable;
